export default __webpack_public_path__ + "static/hirehost-71b3a190021c65821188153ba9d59021.svg";